import { useOperationConfigModelStore } from '@/models/operation-config/operationConfig';
import type { Example } from '@tarslib/types/lib/httpApi';
import React from 'react';

export function useRequestExampleValue(
  requestExamples: (Example & {
    key: string;
  })[],
) {
  const selectedRequestKey = useOperationConfigModelStore((x) => x.selectedRequestKey);
  const setSelectedRequestKey = useOperationConfigModelStore((x) => x.setSelectedRequestKey);

  const selectedRequestExample = React.useMemo(() => {
    return requestExamples.find((x) => x.key === selectedRequestKey && selectedRequestKey);
  }, [selectedRequestKey, requestExamples]);

  React.useEffect(() => {
    if (!selectedRequestExample && requestExamples[0]?.key) {
      setSelectedRequestKey(requestExamples[0].key);
    }
  }, [selectedRequestExample, setSelectedRequestKey, requestExamples]);

  React.useEffect(() => {
    if (requestExamples[0]?.key) {
      setSelectedRequestKey(requestExamples[0].key);
    }
  }, [requestExamples, setSelectedRequestKey]);

  const selectedRequestExampleWithDefault = React.useMemo(() => {
    return selectedRequestExample ?? requestExamples[0];
  }, [requestExamples, selectedRequestExample]);

  return {
    requestExamples,
    selectedRequestExample: selectedRequestExampleWithDefault,
    setSelectedRequestKey,
  };
}
